export const palletErrors = {
  loans: {
    PoolMissing: "Pool doesn't exist",
    PoolNotInitialised: 'Pool is not initialised',
    PoolAlreadyInitialised: 'Pool is already initialised',
    MissingLoan: "Loan doesn't exist",
    LoanCeilingReached: 'Borrowed amount is more than ceiling',
    ValueOverflow: 'An operation lead to a number overflow',
    PrincipalDebtOverflow: 'Principal debt calculation failed due to overflow',
    LoanIsActive: "Can't update an active loan",
    LoanTypeInvalid: 'Loan type given is not valid',
    LoanNotActive: 'Operation is done on an inactive loan',
    RepayTooEarly: 'Borrow and repay happens in the same block',
    NFTOwnerNotFound: 'The NFT owner is not found',
    NotAssetOwner: "Nft owner doesn't match the expected owner",
    NotAValidAsset: 'The nft is not an acceptable asset',
    NftTokenNonceOverflowed: 'The nft token nonce is overflowed',
    LoanNotRepaid: 'Loan amount not repaid but trying to close loan',
    LoanMaturityDatePassed: 'Maturity has passed and borrower tried to borrow more',
    LoanValueInvalid: 'A loan data value is invalid',
    LoanAccrueFailed: 'Loan accrue calculation failed',
    LoanPresentValueFailed: 'Loan present value calculation failed',
    LoanHealthy: 'Trying to write off of a healthy loan',
    WrittenOffByAdmin: 'Trying to write off loan that was written off by admin already',
    NoValidWriteOffGroup: 'There is no valid write off group available for unhealthy loan',
    InvalidWriteOffGroupIndex: 'There is no valid write off groups associated with given index',
    InvalidWriteOffGroup: 'New write off group is invalid',
  },
  pools: {
    PoolInUse: 'A pool with this ID is already in use',
    InvalidJuniorTranche: 'Attempted to create a pool without a junior tranche',
    MissingTrancheValues: 'Attempted to create a pool with missing tranche inputs',
    NoSuchPool: 'Attempted an operation on a pool which does not exist',
    MinEpochTimeHasNotPassed: 'Attempted to close an epoch too early',
    ChallengeTimeHasNotPassed: 'Attempted to execute an epoch too early',
    InSubmissionPeriod: 'Cannot be called while the pool is in a submission period',
    NAVTooOld: 'Attempted to close an epoch with an out of date NAV',
    Overflow: 'An arithmetic overflow occurred',
    TrancheId: 'A Tranche ID cannot be converted to an address',
    WipedOut: 'Closing the epoch now would wipe out the junior tranche',
    InvalidSolution: 'The provided solution is not a valid one',
    NotInSubmissionPeriod: 'Attempted to solve a pool which is not in a submission period',
    InsufficientCurrency: 'Insufficient currency available for desired operation',
    InsufficientReserve: 'Insufficient reserve available for desired operation',
    RiskBufferViolated: 'Risk Buffer validation failed',
    NoNAV: 'The NAV was not available',
    InvalidData: 'Invalid input',
    EpochNotExecutedYet: 'Epoch needs to be executed before you can collect',
    NoOutstandingOrder: "There's no outstanding order that could be collected",
    CollectRequired: 'Need to collect before a new order can be submitted',
    CannotAddOrRemoveTranches: 'Adding or removing tranches is not supported',
    InvalidTrancheSeniority: 'Invalid tranche seniority value',
    BadMetadata: 'Invalid metadata passed',
    InvalidTrancheId: 'Invalid TrancheId passed',
    NoNewOrder: 'New order is same as old order',
    NotNewBestSubmission: 'Submitted solution is not an improvement',
    NoSolutionAvailable: 'No solution has yet been provided for the epoch',
    HealtySolutionExists: 'Un-healthy solution was submitted, but a healthy one exists',
  },
}
